import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import useMainBankAccountId from 'common/hooks/useMainBankAccountId';

import { PaymentsHomeQueryDocument } from './paymentsHomeQuery.gql';

export function usePaymentsHomeQuery() {
  const { companyProfileId } = useCompanyContext();
  const { loading: bankAccountIdLoading, mainBankAccountId } =
    useMainBankAccountId();

  const { data, loading } = useQuery(PaymentsHomeQueryDocument, {
    fetchPolicy: 'cache-and-network',
    skip: !companyProfileId || !mainBankAccountId,
    variables: {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      bankAccountId: mainBankAccountId!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      companyProfileId: companyProfileId!,
    },
  });

  return {
    beneficiariesCount:
      data?.viewer.company.bankTransferRecipientsCount.totalCount,
    loading: bankAccountIdLoading || loading,
    mandatesCount: data?.viewer.directDebitMandatesCount.totalCount,
    scheduledTransfersCount:
      data?.viewer.scheduledBankTransfersCount?.totalCount ?? 0,
  };
}
